/**
 * Returns the Dynamic Link URL with the dynamic/data-tag
 * values replaced with attendee data
 */
export default function replaceDynamicUrl(
  linkUrl: string | undefined,
  {
    firstName = '',
    lastName = '',
    email = '',
    id = ''
  }: {
    firstName: string;
    lastName: string;
    email: string;
    id: string;
  }
): string | undefined {
  return linkUrl
    ? linkUrl
        .replace(/{\[FIRST NAME\]}/g, firstName)
        .replace(/{\[LAST NAME\]}/g, lastName)
        .replace(/{\[EMAIL\]}/g, email)
        .replace(/{\[UNIQUE ID\]}/g, id)
    : linkUrl;
}
